import * as Backbone from "backbone";
import {IAppRouter} from "../interfaces/router";
import { OnCueRouter } from "./onCueRouter";

export class AppRouter implements IAppRouter {
    private router: OnCueRouter;
    constructor() {
        this.router = new OnCueRouter();
    }

    public startRouter(): void {
        Backbone.history.start({ pushState: true });
    }

    public navigate(url: string, trigger: boolean): void {
        this.router.navigate(url, { trigger });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/appHost.ts